// data.service.ts
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../../_services/app.service';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { Helpers } from '../../../helpers';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';

@Injectable()
export class EntityService {
      sharedData: any; // This variable will store the shared data
      TransportModeTypeList: any[] = [];
      transportList: any[] = [];
      EntityStatusList: any[] = [];
      driverStatusTypeList: any[] = [];
      constructor(private _appService: appService, private translate: TranslateService,
            private toastr: ToastrService, private datePipe: DatePipe, private modalService: NgbModal) { }

      deleteEntityById(Id): Promise<any> {
            return new Promise((resolve) => {
                  const dialogRef = this.modalService.open(ConfirmationPopupComponent, { centered: true });
                  dialogRef.componentInstance.details = {
                        message: 'Are you sure you want to delete this entity type?',
                        title: 'Confirmation',
                  }
                  dialogRef.componentInstance.close.subscribe((res: any) => {
                        if (res) {
                              Helpers.setLoading(true);
                              this._appService.Delete("ShipmentModes", "DeleteShipmentData", Id).subscribe(response => {
                                    let resSTR = JSON.stringify(response);
                                    let resJSON = JSON.parse(resSTR);
                                    this.toastr.success(
                                          "Detail Deleted Successfully !",
                                          "Success"
                                    );
                                    resolve(1);
                                    Helpers.setLoading(false);
                              }, err => {
                                    Helpers.setLoading(false);
                                    this.toastr.error("An error occured while deleting data !", 'error');
                              });
                        }
                        dialogRef.close();
                  });
            })

      }

      GetTransportModeType(): Promise<any> {
            return new Promise((resolve, reject) => {
                  this._appService
                        .Get("ShipmentModes", "GetTransportModeType")
                        .subscribe(
                              (response) => {
                                    console.log(response);
                                    if (response) {
                                          response.map(x => {
                                                x.name = x.TransportModeTypes;
                                                x.value = x.TransportModeTypeId;
                                          })
                                    }
                                    this.TransportModeTypeList = response;
                                    resolve(response);
                              },
                              (err) => {
                                    this.toastr.error(
                                          "Error occurred while fetching Transport Mode type !",
                                          "error"
                                    );
                                    reject(err);

                              }
                        );
            });
      }

      GetEntityStatus() {
            return this.EntityStatusList = [{ value: '', name: 'All' }, { value: 1, name: 'Active' }, { value: 0, name: 'InActive' }]
      }


}
